export const GET_COMMENTS = "GET_COMMENTS";
export const GET_LIST_COMMENTS = "GET_LIST_COMMENTS";
export const GET_COMMENT = "GET_COMMENT";
export const SET_COMMENTS = "SET_COMMENTS";
export const SET_LIST_COMMENTS = "SET_LIST_COMMENTS";
export const SET_COMMENT = "SET_COMMENT";
export const ADD_COMMENT = "ADD_COMMENT";
export const SET_NEW_COMMENT = "SET_NEW_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
export const SET_EDIT_COMMENT = "SET_EDIT_COMMENT";
export const SET_DELETE_COMMENT = "SET_DELETE_COMMENT";
export const SET_DELETE_MULTI_COMMENT = "SET_DELETE_MULTI_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const DELETE_MULTI_COMMENT = "DELETE_MULTI_COMMENT";
export const RESET_LIST_COMMENTS = "RESET_LIST_COMMENTS";
export const RESET_ITEMS_COMMENT = "RESET_ITEMS_COMMENT";
export const RESET_SELECTED_COMMENT = "RESET_SELECTED_COMMENT";
